import * as React from 'react';

import './UserRolesLegend.css';

import { RoleName } from '@/common/const/Auth';

export const RolesDescriptionsMap: { [role: string]: JSX.Element } = {
  [RoleName.VIEWER]: (
    <>
      Read-only access to GrabX platform (no need to request anywhere, it&apos;s
      by default).
    </>
  ),
  [RoleName.EDITOR]: (
    <>
      To create, update, delete resources(variable/rollout/experiment ..) for
      selected TF scope in Concedo.
    </>
  ),
  [RoleName.PUBLISHER]: (
    <>
      All permissions of Editor plus approve, abort, reject experiments and
      rollouts for selected TF scope in Concedo.
    </>
  ),
  [RoleName.ROLLOUT_MODERATOR]: (
    <>
      All permissions of Editor plus approve, disable, reject rollouts for
      selected TF scope in Concedo.
    </>
  ),
  [RoleName.EXPERIMENT_MODERATOR]: (
    <>
      All permissions of Editor plus approve, abort, reject experiments for
      selected TF scope in Concedo.
    </>
  ),
  [RoleName.MODERATOR]: (
    <>
      Rollout and Experiment moderator (but not editor) actions for selected TF
      scope in Concedo(only for TF heads and direct reports).
    </>
  ),
  [RoleName.TECH_SUPPORT]: (
    <>All permission of Publisher for all of the allowed TFs.</>
  ),
  [RoleName.ADMIN]: (
    <>
      GrabX platform admin (Strictly for GrabX engineers). Requests outside of
      the GrabX team will be rejected.
    </>
  ),
};

export default RolesDescriptionsMap;
